import { axiosInstanceAuth } from "./client";
import { ILocation } from "interfaces";
import { useQuery } from "@tanstack/react-query";

export const useGetLocations = () => {
	return useQuery({
		queryKey: ["GET_LIST_LOCATIONS"],
		queryFn: async () => {
			const res = await axiosInstanceAuth.get("/locations");
			return res as ILocation[];
		},
	});
};
